import { useMutation } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

export function useSetAccountEnabled(accountId: string) {
  return useMutation({
    mutationFn: async (enabled: boolean) => {
      if (enabled) {
        return UsersService.updateAccount(accountId, { is_enabled: true });
      }

      // Disabled accounts must not keep any access, so all of their roles and vendors are removed in the same update.
      // Vendors are cleared explicitly so a re-enabled account is not silently re-linked to its old vendors.
      const updatedAccount = await UsersService.updateAccount(accountId, { is_enabled: false, roles: [], vendors: [] });
      return { ...updatedAccount, roles: updatedAccount?.roles ?? [], vendors: updatedAccount?.vendors ?? [] };
    },
  });
}
